/** Vite-only env bridge so shared/api.ts (process.env) works in the browser. */
if (typeof process === "undefined") {
  (globalThis as { process?: { env: Record<string, string> } }).process = { env: {} };
}
const env = (globalThis as { process: { env: Record<string, string> } }).process.env;
// Solo la URL del backend (acceso explícito: nunca `import.meta.env` entero, que publicaría todo el .env).
const backend = String(import.meta.env.VITE_BACKEND_URL || "").trim();
if (backend) {
  env.VITE_BACKEND_URL = backend;
  env.EXPO_PUBLIC_BACKEND_URL = backend;
}
